// extracted by mini-css-extract-plugin
export default {"wrapper":"MyIa9q","marquee":"Q13PeQ","animate":"jM7yQw","text":"wMKpAr"};